import { Model } from "./Base.js";

export class ProprietarioModel extends Model {
    get defaults() {
        return {
            nome: "",
            cnpj: "",
            usuario: "",
        };
    }
}